import * as React from 'react';
import '../css/pc/AccountBindingTabs.css';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import AccountBindingByEmailInputTab from './AccountBindingByEmailInputTab';
import AccountBindingByQrCodeTab from "./AccountBindingByQrCodeTab";
import AccountBindingByCookieTab from './AccountBindingByCookieTab';
import AccountBindingBySsoTab from './AccountBindingBySsoTab';
import classNames from 'classnames/bind';
import styles from '../css/pc/PcGeneral.module.css';

const cx = classNames.bind(styles);

export default function AccountBindingTabs() {
  const {t, i18n} = useTranslation();
  const {isSSOIntegrated} = useSelector((state) => state.userDetailsResponse);
  const cookieValue = useSelector((state) => state.cookieDetails.cookieValue);
  const paymentTabs = useSelector((state) => state.paymentTabs.paymentTabs);
  const [isQrTabEnabled] = useState(paymentTabs.includes("QR"));
  const [isEmailTabEnabled] = useState(paymentTabs.includes("EMAIL"));
  const [isExpressCheckoutSelected, setIsExpressCheckoutSelected] = useState(isEmailTabEnabled && isSSOIntegrated);
  const [isEmailTabSelected, setIsEmailTabSelected] = useState(!isQrTabEnabled && !isSSOIntegrated);
  const [isQrTabSelected, setIsQrTabSelected] = useState(isQrTabEnabled && !isExpressCheckoutSelected);

  const handleTabClick = (e) => {
    e.preventDefault();

    if (e.target.id === 'expressTab') {
      setIsExpressCheckoutSelected(true);
      setIsEmailTabSelected(false);
      setIsQrTabSelected(false);
    } else if (e.target.id === 'emailTab') {
      setIsExpressCheckoutSelected(false);
      setIsEmailTabSelected(true);
      setIsQrTabSelected(false);
    } else {
      setIsExpressCheckoutSelected(false);
      setIsEmailTabSelected(false);
      setIsQrTabSelected(true);
    }
  };

  const handleDivTabClassName = () => {
    if (isQrTabEnabled && isSSOIntegrated && isQrTabSelected) {
      return "mpi-qr-payment-tab-with-sso";
    } else if (isQrTabEnabled && isSSOIntegrated && !isQrTabSelected) {
      return "mpi-payment-tab-with-sso";
    } else if (isQrTabEnabled && !isSSOIntegrated && isQrTabSelected) {
      return "mpi-qr-payment-tab";
    } else if (isSSOIntegrated && cookieValue) {
      return "mpi-payment-tab-cookie-sso";
    } else if (!isSSOIntegrated && cookieValue) {
      return "mpi-payment-tab-cookie";
    } else {
      return "mpi-payment-tab";
    }
  };

  const renderForm = () => {
    if (isQrTabEnabled && isQrTabSelected) {
      return <AccountBindingByQrCodeTab/>;
    }

    if (isEmailTabEnabled) {
      if (isSSOIntegrated && isExpressCheckoutSelected) {
        return <AccountBindingBySsoTab/>;
      }

      if (isEmailTabSelected && cookieValue) {
        return <AccountBindingByCookieTab/>;
      } else {
        return <AccountBindingByEmailInputTab/>;
      }
    }
  };

  return (
    <>
      <div className={`${cx('mpi-content')} mpi-step-Enterinfo`} lang={i18n.language}>
        <p className={cx('mpi-requestpay-text')} lang={i18n.language}>
          {isExpressCheckoutSelected || isEmailTabSelected ? t('pay.gsmpi.main.msg2.2') : t('pay.gsmpi.qr.scanQrMessage')}
        </p>
        {isEmailTabEnabled && isSSOIntegrated &&
          <div className={handleDivTabClassName()} lang={i18n.language}>
            <p id="expressTab" className={isExpressCheckoutSelected ? "mpi-payment-tab-selected" : "mpi-payment-tab-unselected"} onClick={handleTabClick}>
              {t('pay.gsmpi.main.account')}
            </p>
          </div>
        }
        {isQrTabEnabled &&
          <div className={handleDivTabClassName()} lang={i18n.language}>
            <p id="qrTab" className={isQrTabSelected ? "mpi-payment-tab-selected" : "mpi-payment-tab-unselected"} onClick={handleTabClick}>
              {t('pay.gsmpi.main.scanQr')}
            </p>
          </div>
        }
        {isEmailTabEnabled &&
          <div className={handleDivTabClassName()} lang={i18n.language}>
            <p id="emailTab" className={isEmailTabSelected ? "mpi-payment-tab-selected" : "mpi-payment-tab-unselected"} onClick={handleTabClick}>
              {t('pay.gsmpi.main.email')}
            </p>
          </div>
        }
      </div>
      {renderForm()}
    </>
  );
}
